import { render } from "./ProgressPreloader.vue?vue&type=template&id=645bfaae&scoped=true&ts=true"
import script from "./ProgressPreloader.vue?vue&type=script&lang=ts"
export * from "./ProgressPreloader.vue?vue&type=script&lang=ts"

import "./ProgressPreloader.vue?vue&type=style&index=0&id=645bfaae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645bfaae"]])

export default __exports__